export default __webpack_public_path__ + "static/media/empty.aa010a4c.png";